// src/admin/components/InviteTable.jsx
import React, { useEffect, useState } from 'react';
import { db } from '../../common/firebase';
import { collection, getDocs } from 'firebase/firestore/lite';
import '../styles/InviteTable.css';

export default function InviteTable() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const snap = await getDocs(collection(db, 'invites'));
        setRows(snap.docs.map(d => ({ code: d.id, ...d.data() })));
      } catch (err) {
        console.error('Invites Fetch Error ▶', err);
        alert('⚠️ 초대코드 불러오기 실패');
      }
    })();
  }, []);

  if (!rows.length) return <p>데이터가 없습니다.</p>;

  return (
    <table className="invite-table">
      <thead>
        <tr>
          <th>코드</th>
          <th>발급일</th>
          <th>클릭수</th>
          <th>설치수</th>
        </tr>
      </thead>
      <tbody>
        {rows.map(r => (
          <tr key={r.code}>
            <td>{r.code}</td>
            <td>{r.issuedAt}</td>
            <td>{r.clicks}</td>
            <td>{r.installs}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
